<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex> Edit Image </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-5">
        <v-flex>
          <div class="subtitle-2 mb-1">Select Entity</div>
          <v-combobox
            :loading="loading"
            v-model="entity"
            :items="reviewedEntities"
            cache-items
            :search-input.sync="searchTerm"
            hide-details
            return-object
            item-text="title"
            item-value="title"
            placeholder="Select Entity"
            no-data-text="Type a name of an entity to search"
            outlined
            chips
            dense
          ></v-combobox>
        </v-flex>
      </v-layout>
      <v-layout class="mx-5 my-3">
        <v-flex>
          <v-card>
            <v-img :src="imageUrl" :lazy-src="imageUrl"> </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      dialog: false,
      entity: "",
      imageUrl: "",
      firebaseUrl: "",
      imageThumbnail: "",
      searchTerm: "",
      id: "",

      loading: false,
    };
  },
  computed: {
    ...mapState("$_entity", ["reviewedEntities"]),
    changeFields() {
      return {
        id: this.id,
        image: {
          firebaseUrl: this.firebaseUrl,
          thumbnail: this.imageThumbnail,
          url: this.imageUrl,
        },

        entity: this.entity,
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  methods: {
    ...mapActions({
      searchEntitiesAction: "$_entity/searchContent",
    }),
    searchEntities(searchTerm) {
      this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    cancel() {
      this.entity = "";
      this.imageUrl = "";
      this.firebaseUrl = "";
      this.imageThumbnail = "";
      this.searchTerm = "";
      this.id = "";
      this.dialog = false;
    },
    save() {
      console.log("Saving Edited Image: ", this.changeFields);
    },
    toggleDialog(details) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.imageUrl = details.image.url;
        this.firebaseUrl = details.image.firebaseUrl ? details.image.firebaseUrl : "" ;
        this.imageThumbnail = details.image.thumbnail;
        this.entity = details.entity;

        this.id = details.id;
      }
    },
  },
};
</script>

<style>
</style>